import DuplicateSpecContainer from "./DuplicateSpecContainer";
export default DuplicateSpecContainer;
